import type { ApiModuleEndpoints } from '../types'

export const printTemplateApiEndpoints = {
  list: {
    method: 'GET',
    path: '/settings/print-templates',
    requiresAuth: true,
  },
  detail: {
    method: 'GET',
    path: '/settings/print-templates/:documentType',
    requiresAuth: true,
  },
  update: {
    method: 'PUT',
    path: '/settings/print-templates/:documentType',
    requiresAuth: true,
  },
  reset: {
    method: 'POST',
    path: '/settings/print-templates/:documentType/reset',
    requiresAuth: true,
  },
} as const satisfies ApiModuleEndpoints
